import styled from 'styled-components';
import { deviceSizes } from '../../../../config/devices';
// export const CardContainer = styled.div`
// padding-right: 2rem;
// padding-bottom: 2rem;
// `;

export var HeaderContainer = styled.div.withConfig({
  displayName: "style__HeaderContainer",
  componentId: "sc-g1z4zl-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:1rem;padding:1.5rem;&&{border-radius:13px;}@media (max-width:", "){flex-direction:column;}"], deviceSizes.sm);
export var TitleContainer = styled.div.withConfig({
  displayName: "style__TitleContainer",
  componentId: "sc-g1z4zl-1"
})(["display:flex;flex-direction:row;align-items:center;svg{margin-right:0.5rem;font-size:40px;color:", ";}@media (max-width:", "){justify-content:center;margin-bottom:20px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme && theme.grey[700];
}, deviceSizes.md);